import { useState } from "react";
import { PawPrint, Cat, Dog } from "lucide-react";

export default function CaseImage({ src, alt, className, animalType, testId }) {
  const [error, setError] = useState(false);

  if (!src || error) {
    const Icon = animalType === "Cat" ? Cat : animalType === "Dog" ? Dog : PawPrint;
    return (
      <div data-testid={testId} className={`flex items-center justify-center bg-amtm-bg ${className || ""}`}>
        <Icon className="h-6 w-6 text-amtm-textMuted" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      data-testid={testId}
      onError={() => setError(true)}
      referrerPolicy="no-referrer"
    />
  );
}
